import React, { useMemo, useState } from "react";
import DictionaryHeader from "../components/diccionario/DictionaryHeader";
import DictionaryList from "../components/diccionario/DictionaryList";

// ✅ Importa explícito (simple y funciona en CRA / Vite / Next)
import aData from "../data/diccionario/letters/a.json";
import bData from "../data/diccionario/letters/b.json";
import cData from "../data/diccionario/letters/c.json";
import dData from "../data/diccionario/letters/d.json";
import eData from "../data/diccionario/letters/e.json";
import fData from "../data/diccionario/letters/f.json";
import gData from "../data/diccionario/letters/G.json";
import hData from "../data/diccionario/letters/H.json";
import iData from "../data/diccionario/letters/I.json";
import jData from "../data/diccionario/letters/J.json";
import kData from "../data/diccionario/letters/K.json";
import lData from "../data/diccionario/letters/L.json";
import mData from "../data/diccionario/letters/M.json";
import nData from "../data/diccionario/letters/N.json";
import oData from "../data/diccionario/letters/O.json";
import pData from "../data/diccionario/letters/P.json";
import qData from "../data/diccionario/letters/Q.json";
import rData from "../data/diccionario/letters/R.json";
import sData from "../data/diccionario/letters/S.json";
import tData from "../data/diccionario/letters/T.json";
import uData from "../data/diccionario/letters/U.json";
import vData from "../data/diccionario/letters/V.json";
import wData from "../data/diccionario/letters/W.json";
import xData from "../data/diccionario/letters/X.json";
import yData from "../data/diccionario/letters/Y.json";
import zData from "../data/diccionario/letters/Z.json";

export const BY_LETTER = {
    A: aData,
  B: bData,
  C: cData,
  D: dData,
  E: eData,
  F: fData,
  G: gData,
  H: hData,
  I: iData,
  J: jData,
  K: kData,
  L: lData,
  M: mData,
  N: nData,
  O: oData,
  P: pData,
  Q: qData,
  R: rData,
  S: sData,
  T: tData,
  U: uData,
  V: vData,
  W: wData,
  X: xData,
  Y: yData,
  Z: zData,
};



export default function CryptoDictionaryABC() {
  const [letter, setLetter] = useState("A");
  const [query, setQuery] = useState("");

  const items = useMemo(() => {
    const pack = BY_LETTER[letter] || { entries: [] };
    const q = query.trim().toLowerCase();
    if (!q) return pack.entries;

    return pack.entries.filter((it) => {
      const hay = `${it.term} ${it.definition} ${(it.tags || []).join(" ")} ${(it.category || "")}`.toLowerCase();
      return hay.includes(q);
    });
  }, [letter, query]);

  return (
    <div style={{ padding: 18, maxWidth: 1200, margin: "0 auto" }}>
      <DictionaryHeader
        letter={letter}
        setLetter={setLetter}
        query={query}
        setQuery={setQuery}
        letters={Object.keys(BY_LETTER)}
      />
      <DictionaryList items={items} />
    </div>
  );
}
